import { parsePhoneNumberFromString } from 'libphonenumber-js';

const DEFAULT_COUNTRY = 'US';

const PHONE_NAME_PATTERN = /phone|tel(ephone)?|mobile|cell|fax/i;
const EMAIL_NAME_PATTERN = /e[-]?mail/i;

/**
 * Detects if a guest field name represents a phone field.
 */
export function isPhoneField(fieldName) {
    return PHONE_NAME_PATTERN.test(fieldName || '');
}

/**
 * Detects if a guest field name represents an email field.
 */
export function isEmailField(fieldName) {
    return EMAIL_NAME_PATTERN.test(fieldName || '');
}

/**
 * Basic email validation. Returns an error string or undefined.
 */
export function validateEmail(email) {
    if (!email) {
        return undefined;
    }
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!pattern.test(email)) {
        return 'Please enter a valid email address.';
    }
    return undefined;
}

/**
 * Validates a phone number. Returns an error string or undefined.
 */
export function validatePhone(phone) {
    if (!phone) {
        return 'Phone is required.';
    }
    const parsed = parsePhoneNumberFromString(String(phone), DEFAULT_COUNTRY);
    if (!parsed || !parsed.isValid()) {
        return 'Please enter a valid phone number.';
    }
    return undefined;
}

/**
 * Formats a phone number for display.
 * US numbers use national format: (808) 555-1234
 * International numbers use international format: +36 30 940 1763
 * Returns the original value if parsing fails.
 */
export function formatPhone(phone) {
    if (!phone) {
        return phone;
    }
    const parsed = parsePhoneNumberFromString(String(phone), DEFAULT_COUNTRY);
    if (!parsed || !parsed.isValid()) {
        return phone;
    }
    return parsed.country === 'US' ? parsed.formatNational() : parsed.formatInternational();
}

/**
 * Converts a phone number to E.164 format (+18085551234).
 * Returns the original value if parsing fails.
 */
export function toE164(phone) {
    if (!phone) {
        return phone;
    }
    const parsed = parsePhoneNumberFromString(String(phone), DEFAULT_COUNTRY);
    if (!parsed || !parsed.isValid()) {
        return phone;
    }
    return parsed.format('E.164');
}
